import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=7a1e9680&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=7a1e9680&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e9680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1e9680')) {
      api.createRecord('7a1e9680', component.options)
    } else {
      api.reload('7a1e9680', component.options)
    }
    module.hot.accept("./NotificationList.vue?vue&type=template&id=7a1e9680&scoped=true", function () {
      api.rerender('7a1e9680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/NotificationList.vue"
export default component.exports